type Size = "sm" | "md" | "lg" | "hero";

const sizeMap: Record<Size, string> = {
  sm: "size-16",
  md: "size-32",
  lg: "size-64",
  hero: "size-[22rem] md:size-[26rem]",
};

export function GlassOrb({ size = "md", className = "" }: { size?: Size; className?: string }) {
  return (
    <div className={`relative ${sizeMap[size]} ${className}`}>
      {/* Outer glow */}
      <div
        aria-hidden
        className="absolute -inset-12 rounded-full blur-3xl opacity-70 animate-pulse-glow"
        style={{ background: "radial-gradient(circle, rgba(217,70,239,0.55), transparent 65%)" }}
      />
      {/* Orb */}
      <div className="relative w-full h-full rounded-full orb-surface animate-orb-drift overflow-hidden">
        {/* Inner highlight */}
        <div
          aria-hidden
          className="absolute top-[12%] left-[18%] w-[40%] h-[30%] rounded-full blur-2xl"
          style={{ background: "radial-gradient(circle, rgba(255,255,255,0.85), transparent 70%)" }}
        />
        {/* Bottom horizon shimmer */}
        <div
          aria-hidden
          className="absolute bottom-[8%] left-[10%] right-[10%] h-[14%] rounded-full blur-xl opacity-80"
          style={{
            background: "linear-gradient(90deg, transparent, rgba(244,114,208,0.95), transparent)",
          }}
        />
        {/* Glass ring */}
        <div className="absolute inset-0 rounded-full border border-white/30" />
        <div className="absolute inset-2 rounded-full border border-white/10" />
      </div>
    </div>
  );
}
